import React from "react";
import { CheckIcon, XCircleIcon, BookOpenIcon, PencilIcon, BrainIcon, SproutIcon, ArrowDownIcon, DownloadIcon, ZapIcon, HeartIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Testimonials } from "./Testimonials";
import { CART_URL, HERO_POSTER, EBOOK_MOCKUP } from "./salesData";
function Check({
  children
}: {
  children: React.ReactNode;
}) {
  return <li className="flex items-start gap-3" data-id="element-18" data-mp="2syrt18wi554v">
      <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-green-500" strokeWidth={3} data-id="element-19" data-mp="2t14j69ceylt0" />
      <span data-id="element-20" data-mp="2xxmn56zx6g4a">{children}</span>
    </li>;
}
const modules = ["Comparación constante", "Autoestima", "Dirección personal", "Bloqueo mental", "Progreso real", "Hábitos mentales", "Constancia", "Construcción de identidad"];
const benefits = ["Dejar de sentir culpa por “ir atrasado”", "Entender tu propio ritmo", "Dejar de obsesionarte con la vida ajena", "Tomar decisiones con más claridad", "Construir confianza real", "Sentir que avanzás otra vez"];
const forYou = ["Te comparás constantemente", "Sentís que todos avanzan menos vos", "Te cuesta encontrar dirección", "Vivís pensando que ya es tarde", "Querés cambiar pero no sabés por dónde empezar", "Necesitás volver a confiar en vos"];
export function SalesPage() {
  return <main className="w-full bg-white font-sans text-[#0d1b3e]" data-id="element-21" data-mp="1px0ywhnm2qo">
      {/* Sticky top bar */}
      <div className="sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-white/10 bg-[#0d1b3e] px-4 py-2.5 text-white sm:px-6" data-id="element-22" data-mp="fh280jncpxb1">
        <span className="text-xs font-semibold uppercase tracking-wide sm:text-sm" data-id="element-23" data-mp="biur9osw0vzu">
          📘 Todos Avanzan Menos Vos — Ebook
        </span>
        <a href={CART_URL} target="_blank" rel="noopener noreferrer" className="rounded-lg bg-[#f5a623] px-4 py-2 text-xs font-extrabold uppercase text-[#0d1b3e] transition-colors hover:bg-[#ffb52e] sm:text-sm" data-id="element-24" data-mp="ki81ijou5olm">
          Empezar hoy
        </a>
      </div>

      {/* ============ HERO ============ */}
      <section className="w-full bg-white px-5 pb-16 pt-10 sm:pt-14" data-id="element-25" data-mp="q7rgtndkwdw4">
        <div className="mx-auto max-w-3xl text-center" data-id="element-26" data-mp="v51axgbwxdqa">
          <p className="inline-block rounded-full bg-[#0d1b3e]/5 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-[#1e4fa3]" data-id="element-27" data-mp="z5laeqjyktfl">
            Ebook práctico + ejercicios reales
          </p>
          <h1 className="mt-5 text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl" data-id="element-28" data-mp="194sojfyios3r">
            Todos avanzan
            <br data-id="element-29" data-mp="1e22in8wuprxx" />
            <span className="text-[#1e4fa3]" data-id="element-30" data-mp="1e1iz5nrjyvhs">menos vos</span>
          </h1>

          {/* Product image — right under title, before subtitle */}
          <div className="mx-auto mt-8 max-w-md" data-id="element-31" data-mp="1mw757g4ych7n">
            <img src={HERO_POSTER} alt="Portada del ebook Todos Avanzan Menos Vos" className="mx-auto w-full rounded-2xl shadow-2xl ring-1 ring-black/5" data-id="element-32" data-mp="1muw11f7lh7g0" />
          </div>

          <p className="mx-auto mt-8 max-w-2xl text-lg font-medium leading-relaxed text-gray-700 sm:text-xl" data-id="element-33" data-mp="26xs9kfzr25vf">
            Cómo dejar de sentirte un fracaso, dejar de compararte y empezar a
            construir tu propio camino.
          </p>

          <ul className="mx-auto mt-8 max-w-xl space-y-3 text-left text-base text-gray-700 sm:text-lg" data-id="element-34" data-mp="1x0nka7alxuae">
            <li className="flex items-start gap-3" data-id="element-35" data-mp="1szc3mr9pojec">
              <span className="text-xl" data-id="element-36" data-mp="2po9xm79n0dag">🚫</span>
              <span data-id="element-37" data-mp="2pmyn7olos7ad">Dejá de sentir que llegaste tarde a la vida.</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-38" data-mp="2kq87j2dsndph">
              <span className="text-xl" data-id="element-39" data-mp="2krjbp3b5inh4">💭</span>
              <span data-id="element-40" data-mp="2fxf3kgq5g9eg">Recuperá claridad, dirección y confianza.</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-41" data-mp="2bxodkf8g5xaz">
              <span className="text-xl" data-id="element-42" data-mp="2busdold1gyjw">🌱</span>
              <span data-id="element-43" data-mp="38f18jd99wbqy">
                Aprendé a avanzar a tu ritmo sin vivir comparándote con los
                demás.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-44" data-mp="33m7zweaooj9l">
              <span className="text-xl" data-id="element-45" data-mp="2o59qpm3hc87v">👉</span>
              <span data-id="element-46" data-mp="2t54hlpn98xsx">
                Ebook práctico + ejercicios reales + herramientas mentales
                aplicables desde el día 1.
              </span>
            </li>
          </ul>

          <div className="mt-10 flex flex-col items-center" data-id="element-47" data-mp="2f7pn46i59zu3">
            <CTAButton size="lg" data-id="element-48" data-mp="2j7q33vkw6j39">Quiero empezar hoy</CTAButton>
            <ul className="mt-5 flex flex-col items-start gap-2 text-sm font-medium text-gray-600 sm:flex-row sm:gap-6" data-id="element-49" data-mp="36wsp1fmk6y3k">
              <li className="flex items-center gap-2" data-id="element-50" data-mp="3bukiie2uqs9v">
                <CheckIcon className="h-4 w-4 text-green-500" strokeWidth={3} data-id="element-51" data-mp="3bxgl4fpna54n" /> Descarga inmediata
              </li>
              <li className="flex items-center gap-2" data-id="element-52" data-mp="325kjwvs9hyw7">
                <CheckIcon className="h-4 w-4 text-green-500" strokeWidth={3} data-id="element-53" data-mp="323zpd65y6fyc" /> Lectura simple y directa
              </li>
              <li className="flex items-center gap-2" data-id="element-54" data-mp="3ptkb1wthjrbb">
                <CheckIcon className="h-4 w-4 text-green-500" strokeWidth={3} data-id="element-55" data-mp="3umwulsjb57x7" /> Sin frases vacías ni humo motivacional
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* ============ IDENTIFICACIÓN EMOCIONAL (dark) ============ */}
      <section className="w-full bg-[#0d1b3e] px-5 py-16 text-white sm:py-24" data-id="element-56" data-mp="1sxh6p6ogbknk">
        <div className="mx-auto max-w-2xl" data-id="element-57" data-mp="1nxut2w4po2e8">
          <h2 className="text-center text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-58" data-mp="1nz5zl3pjjo91">
            Sentís que todos avanzan…{" "}
            <span className="text-[#f5a623]" data-id="element-59" data-mp="10ad1b0lg54b9">menos vos.</span>
          </h2>

          <p className="mt-10 text-lg text-white/80" data-id="element-60" data-mp="vaqnaoxsnk1e">Ves personas de tu edad:</p>
          <ul className="mt-4 grid grid-cols-2 gap-3 text-white/90" data-id="element-61" data-mp="1a7hliuvqeppf">
            {["consiguiendo trabajo", "formando parejas", "recibiéndose", "viajando", "creciendo"].map(t => <li key={t} className="rounded-lg bg-white/5 px-4 py-3 text-center text-sm font-medium sm:text-base" data-id="element-62" data-mp="2lkk1bnq0bb8j">
                  {t}
                </li>)}
          </ul>

          <p className="mt-10 text-lg text-white/80" data-id="element-63" data-mp="2sotb0liehvxc">Y mientras tanto vos sentís que:</p>
          <ul className="mt-4 space-y-2" data-id="element-64" data-mp="2sqmnihfp3ad9">
            {["estás perdido/a", "no avanzás", "llegaste tarde", "algo está mal con vos"].map(t => <li key={t} className="flex items-center gap-3 text-white/90" data-id="element-65" data-mp="32ly3f32uanml">
                <XCircleIcon className="h-5 w-5 shrink-0 text-red-400" data-id="element-66" data-mp="24zqxnpusup8n" />
                {t}
              </li>)}
          </ul>

          <p className="mt-10 text-lg text-white/80" data-id="element-67" data-mp="29ytqmbxi9509">Entonces empezás a castigarte:</p>
          <div className="mt-4 space-y-3" data-id="element-68" data-mp="2ewmxl76mu31l">
            {["“soy un fracaso”", "“todos pueden menos yo”", "“ya debería haber logrado más”"].map(t => <p key={t} className="border-l-4 border-red-400/60 pl-4 text-lg italic text-white/70" data-id="element-69" data-mp="1m999lykwwhtm">
                  {t}
                </p>)}
          </div>

          <div className="mt-12 rounded-2xl bg-[#f5a623] p-8 text-center text-[#0d1b3e]" data-id="element-70" data-mp="8c6a6nfr6fc5">
            <p className="text-2xl font-black sm:text-3xl" data-id="element-71" data-mp="4cfj0imbdx73">Pero el problema no sos vos.</p>
            <p className="mt-3 text-lg font-medium" data-id="element-72" data-mp="3vg49s7d1u4ci">
              El problema es que estás midiendo tu vida con la vara equivocada.
            </p>
          </div>
        </div>
      </section>

      {/* ============ PRESENTACIÓN DEL PRODUCTO ============ */}
      <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-73" data-mp="3gsrliavuxkif">
        <div className="mx-auto grid max-w-5xl items-center gap-12 lg:grid-cols-2" data-id="element-74" data-mp="3gr858ka7b9gn">
          <div className="order-2 lg:order-1" data-id="element-75" data-mp="3crfrlt5yad4f">
            <h2 className="text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-76" data-mp="37s36bcuq9e3y">
              Este ebook te ayuda a salir de ese patrón mental.
            </h2>
            <div className="mt-6 space-y-1 text-lg text-gray-600" data-id="element-77" data-mp="32rynhg6ck7ak">
              <p data-id="element-78" data-mp="2xuoqnfgmotcp">No con frases vacías.</p>
              <p data-id="element-79" data-mp="2xvqd0g33h29q">No con positivismo falso.</p>
              <p data-id="element-80" data-mp="qi6y2735le8u">No diciéndote “amate a vos mismo” y listo.</p>
            </div>
            <p className="mt-6 text-lg font-semibold" data-id="element-81" data-mp="ujs7fighbaea">
              Sino con un sistema claro para:
            </p>
            <ul className="mt-4 space-y-3 text-lg text-gray-700" data-id="element-82" data-mp="gl29k0lu56ov">
              <Check data-id="element-83" data-mp="gmn7m07cz7rh">dejar de compararte constantemente</Check>
              <Check data-id="element-84" data-mp="lhsnoie2xs7n">entender qué te está frenando realmente</Check>
              <Check data-id="element-85" data-mp="6u7m4swus11u">recuperar dirección</Check>
              <Check data-id="element-86" data-mp="6sd01b9ui2w6">construir objetivos propios</Check>
              <Check data-id="element-87" data-mp="blfudlmg5gdf">generar progreso real aunque empieces desde cero</Check>
            </ul>
            <div className="mt-8" data-id="element-88" data-mp="3tzyk74ulz3z4">
              <CTAButton data-id="element-89" data-mp="3u0qe8b8k4tna">Quiero salir de este patrón</CTAButton>
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-90" data-mp="2tdwnv3rie6u">
            <img src={EBOOK_MOCKUP} alt="Mockup del ebook en tablet" className="mx-auto w-full max-w-sm" data-id="element-91" data-mp="3k19esbjwfbzr" />
          </div>
        </div>
      </section>

      {/* ============ QUÉ INCLUYE ============ */}
      <section className="w-full bg-gray-50 px-5 py-16 sm:py-24" data-id="element-92" data-mp="35ekggd1dv4uy">
        <div className="mx-auto max-w-4xl" data-id="element-93" data-mp="31dqrrhg49m10">
          <h2 className="text-center text-3xl font-extrabold uppercase sm:text-4xl" data-id="element-94" data-mp="31es5xusfiomy">
            Qué incluye
          </h2>
          <p className="mt-4 text-center text-lg text-gray-600" data-id="element-95" data-mp="3adn9ez439kmk">
            Dentro de <span className="font-bold text-[#0d1b3e]" data-id="element-96" data-mp="3afgfac6vo0ti">“Todos avanzan menos vos”</span> vas a encontrar:
          </p>

          <div className="mt-12 grid gap-6 sm:grid-cols-2" data-id="element-97" data-mp="3kbjilldgu5i1">
            <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm" data-id="element-98" data-mp="3kb1nis2jhxbp">
              <div className="flex items-center gap-3" data-id="element-99" data-mp="1w91h3iqp6bv">
                <BookOpenIcon className="h-7 w-7 text-[#1e4fa3]" data-id="element-100" data-mp="3t451r2l0ee7e" />
                <h3 className="text-xl font-bold" data-id="element-101" data-mp="3t5y78ejvysdt">8 módulos prácticos</h3>
              </div>
              <ul className="mt-4 grid grid-cols-1 gap-2 text-gray-700" data-id="element-102" data-mp="bvzx58j1drdj">
                {modules.map(m => <li key={m} className="flex items-center gap-2 text-sm sm:text-base" data-id="element-103" data-mp="6uu0x0q63lz9">
                    <CheckIcon className="h-4 w-4 shrink-0 text-green-500" strokeWidth={3} data-id="element-104" data-mp="uhw01aytvnwd" />
                    {m}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col gap-6" data-id="element-105" data-mp="kq9hsuo2ook4">
              <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm" data-id="element-106" data-mp="gp7d3ybdzkar">
                <div className="flex items-center gap-3" data-id="element-107" data-mp="1df6xqr4ta99p">
                  <PencilIcon className="h-6 w-6 text-[#1e4fa3]" data-id="element-108" data-mp="1dckpepa3jpqf" />
                  <h3 className="text-lg font-bold" data-id="element-109" data-mp="18gvn4e6ozuqf">Ejercicios accionables</h3>
                </div>
                <p className="mt-2 text-gray-600" data-id="element-110" data-mp="14cnw2acri2p1">No solo leés. Aplicás.</p>
              </div>
              <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm" data-id="element-111" data-mp="zdujck5aufpx">
                <div className="flex items-center gap-3" data-id="element-112" data-mp="3p4hknly1phpx">
                  <BrainIcon className="h-6 w-6 text-[#1e4fa3]" data-id="element-113" data-mp="3p1v7n6sdya0b" />
                  <h3 className="text-lg font-bold" data-id="element-114" data-mp="3k3jwmsqcttgi">Herramientas mentales simples</h3>
                </div>
                <p className="mt-2 text-gray-600" data-id="element-115" data-mp="1zox5fuunohrf">
                  Para cambiar patrones que te frenan hace años.
                </p>
              </div>
              <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm" data-id="element-116" data-mp="28nilnjcnnkp1">
                <div className="flex items-center gap-3" data-id="element-117" data-mp="2df0nsaqezrbl">
                  <SproutIcon className="h-6 w-6 text-[#1e4fa3]" data-id="element-118" data-mp="2dglh5x0zt47v" />
                  <h3 className="text-lg font-bold" data-id="element-119" data-mp="2icsdqz7i13d5">Un enfoque humano y real</h3>
                </div>
                <p className="mt-2 text-gray-600" data-id="element-120" data-mp="2nbder0ukrr2n">Sin exigirte perfección.</p>
              </div>
            </div>
          </div>

          <div className="mt-12 flex justify-center" data-id="element-121" data-mp="2s9n9jace0pnq">
            <CTAButton data-id="element-122" data-mp="2wcblhqweecox">Quiero acceder al ebook</CTAButton>
          </div>
        </div>
      </section>

      {/* ============ BENEFICIOS ============ */}
      <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-123" data-mp="y0388htux0gt">
        <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="11zu4v262eat9">
          <h2 className="text-center text-3xl font-extrabold uppercase sm:text-4xl" data-id="element-125" data-mp="25a80jr9pa0e5">
            Beneficios
          </h2>
          <p className="mt-4 text-center text-lg text-gray-600" data-id="element-126" data-mp="20by297soijob">
            Después de leer este ebook vas a poder:
          </p>
          <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-127" data-mp="2ech8qahhxhod">
            {benefits.map(b => <div key={b} className="flex items-start gap-3 rounded-xl bg-gray-50 p-5 text-gray-800" data-id="element-128" data-mp="2a7rboib3px1v">
                <span className="text-xl" data-id="element-129" data-mp="2jaabetjlbtjw">✨</span>
                <span className="font-medium" data-id="element-130" data-mp="2j9hcufuscacu">{b}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* ============ FRASE FUERTE (dark) ============ */}
      <section className="w-full bg-[#0d1b3e] px-5 py-20 text-center text-white sm:py-28" data-id="element-131" data-mp="2t152qcbp1jc7">
        <div className="mx-auto max-w-3xl" data-id="element-132" data-mp="370d2b6brqtgx">
          <p className="text-4xl font-black leading-tight text-[#f5a623] sm:text-6xl" data-id="element-133" data-mp="36x8nzg4lahcj">
            No estás tarde.
          </p>
          <p className="mt-6 text-xl font-medium leading-relaxed text-white/90 sm:text-2xl" data-id="element-134" data-mp="3llscp8h5b8st">
            Estás aprendiendo a construir una vida más alineada con vos.
          </p>
        </div>
      </section>

      {/* ============ PARA QUIÉN ES ============ */}
      <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-135" data-mp="3cnyf7u7na942">
        <div className="mx-auto max-w-2xl" data-id="element-136" data-mp="3glw38tpoip5v">
          <h2 className="text-center text-3xl font-extrabold sm:text-4xl" data-id="element-137" data-mp="32vsosox1jzqz">
            Este ebook es para vos si…
          </h2>
          <ul className="mt-10 space-y-4" data-id="element-138" data-mp="37mskxryc6dsf">
            {forYou.map(f => <li key={f} className="flex items-center gap-4 rounded-xl border border-gray-100 bg-gray-50 p-5 text-lg text-gray-800" data-id="element-139" data-mp="2sxweu0fubaug">
                <CheckIcon className="h-6 w-6 shrink-0 text-green-500" strokeWidth={3} data-id="element-140" data-mp="2xud10p3hbf4w" />
                {f}
              </li>)}
          </ul>
          <div className="mt-10 flex justify-center" data-id="element-141" data-mp="2ouq167qeehdy">
            <CTAButton data-id="element-142" data-mp="2gvbuippbubmd">Sí, esto es para mí</CTAButton>
          </div>
        </div>
      </section>

      {/* ============ DIFERENCIAL (dark) ============ */}
      <section className="w-full bg-[#0d1b3e] px-5 py-16 text-white sm:py-24" data-id="element-143" data-mp="2bws9crik53v2">
        <div className="mx-auto max-w-2xl text-center" data-id="element-144" data-mp="274h02y1xg5pu">
          <h2 className="text-3xl font-extrabold sm:text-4xl" data-id="element-145" data-mp="233x0lntvsq0j">
            ¿Qué hace diferente a este ebook?
          </h2>
          <p className="mt-6 text-lg text-white/80" data-id="element-146" data-mp="1y53z6trvcpgq">
            Porque no intenta motivarte por 5 minutos.
          </p>
          <p className="mt-4 text-lg font-semibold text-white" data-id="element-147" data-mp="1t4zh4zbbbmoe">Te ayuda a:</p>
          <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-148" data-mp="1o5waxbjljaeu">
            {["entender qué te pasa", "ordenar tu mente", "dejar de castigarte", "empezar a avanzar de verdad"].map(t => <div key={t} className="rounded-xl bg-white/5 px-5 py-4 text-white/90" data-id="element-149" data-mp="3ikyxb0dcmcdj">
                  {t}
                </div>)}
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-3 text-lg font-bold text-[#f5a623]" data-id="element-150" data-mp="10at7nm5t3pu9">
            <span data-id="element-151" data-mp="158unly7xr91i">De forma simple.</span>
            <span data-id="element-152" data-mp="1a1e3x2y0cia0">Humana.</span>
            <span data-id="element-153" data-mp="1a2741l2go9j6">Realista.</span>
          </div>
        </div>
      </section>

      {/* ============ TESTIMONIOS ============ */}
      <Testimonials data-id="element-154" data-mp="1e1xzi22xndu1" />

      {/* ============ OFERTA ============ */}
      <section className="w-full bg-gray-50 px-5 py-16 sm:py-24" data-id="element-155" data-mp="hdi9k4vwv2ge">
        <div className="mx-auto max-w-2xl text-center" data-id="element-156" data-mp="mb9zitczwehy">
          <p className="text-sm font-bold uppercase tracking-widest text-[#f5a623]" data-id="element-157" data-mp="mbtkyk1utl0q">
            Oferta por tiempo limitado
          </p>
          <h2 className="mt-3 text-3xl font-black uppercase leading-tight sm:text-5xl" data-id="element-158" data-mp="vbzu5tqiryu3">
            Hoy podés descargarlo
            <br data-id="element-159" data-mp="21t3dsct85y28" />y empezar.
          </h2>

          <div className="mt-10 rounded-3xl border-2 border-[#0d1b3e]/10 bg-white p-8 shadow-xl sm:p-10" data-id="element-160" data-mp="21s20e1oqkzhc">
            <img src={EBOOK_MOCKUP} alt="Ebook Todos Avanzan Menos Vos" className="mx-auto w-48" data-id="element-161" data-mp="26thok2m7nm3y" />
            <h3 className="mt-6 text-2xl font-extrabold uppercase" data-id="element-162" data-mp="2miioq4ma503">
              📘 Todos avanzan menos vos
            </h3>

            <div className="mx-auto mt-6 max-w-sm rounded-2xl bg-[#0d1b3e] px-6 py-5 text-white" data-id="element-163" data-mp="gmtd2354y1q0">
              <p className="text-xs font-bold uppercase tracking-widest text-[#f5a623]" data-id="element-164" data-mp="borvjmncyagn">
                Precio especial de hoy
              </p>
              <div className="mt-2 flex items-end justify-center gap-3" data-id="element-165" data-mp="3f58o1df308tj">
                <span className="pb-1 text-lg font-semibold text-white/50 line-through" data-id="element-166" data-mp="3f348tzbqfndy">
                  $49.990
                </span>
                <span className="text-4xl font-black tracking-tight sm:text-5xl" data-id="element-167" data-mp="3p2v4w5fxyag5">
                  $19.990
                </span>
              </div>
              <p className="mt-2 text-sm font-semibold text-[#f5a623]" data-id="element-168" data-mp="31bhbrx9yuau4">
                Ahorrás $30.000 hoy
              </p>
            </div>

            <ul className="mx-auto mt-6 max-w-sm space-y-3 text-left text-gray-700" data-id="element-169" data-mp="1bvwv01qxh2ti">
              <Check data-id="element-170" data-mp="1gmvf7cf1el21">Ebook completo</Check>
              <Check data-id="element-171" data-mp="1gnx1ye5f0vzl">Acceso inmediato, sin esperas</Check>
              <Check data-id="element-172" data-mp="12w0eineoza9j">Lectura digital desde cualquier dispositivo</Check>
              <Check data-id="element-173" data-mp="12tnpjqainzmz">Ejercicios prácticos para aplicar desde el día 1</Check>
              <Check data-id="element-174" data-mp="16xvardhrmxgg">Herramientas aplicables desde el primer día</Check>
              <Check data-id="element-175" data-mp="1unzgpriff9am">Un único pago de $19.990</Check>
            </ul>

            <div className="mt-8 flex flex-col items-center" data-id="element-176" data-mp="1zlr7ujb8yrdr">
              <CTAButton size="lg" data-id="element-177" data-mp="1zl7znubefhcx">Quiero dejar de sentirme atrasado/a</CTAButton>
              <p className="mt-4 text-sm font-medium text-gray-500" data-id="element-178" data-mp="1llgijkpl5kup">
                💛 Empezá hoy. A tu ritmo.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-xs font-medium text-gray-500 sm:gap-6" data-id="element-179" data-mp="a72wmlee7fhb">
              <span className="flex items-center gap-1.5" data-id="element-180" data-mp="f6fr9sbi9qug">
                <DownloadIcon className="h-4 w-4 text-[#1e4fa3]" data-id="element-181" data-mp="f3td39u40d39" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-182" data-mp="11unt9xhpcc8y">
                <ZapIcon className="h-4 w-4 text-[#1e4fa3]" data-id="element-183" data-mp="11t2yq7ve0tb3" /> Acceso digital
              </span>
              <span className="flex items-center gap-1.5" data-id="element-184" data-mp="ww31mmgin0w4">
                <HeartIcon className="h-4 w-4 text-[#1e4fa3]" data-id="element-185" data-mp="rwzumwgz6kli" /> A tu ritmo
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ============ CIERRE EMOCIONAL (dark) ============ */}
      <section className="w-full bg-[#0d1b3e] px-5 py-20 text-center text-white sm:py-28" data-id="element-186" data-mp="1km6vi23wjm9x">
        <div className="mx-auto max-w-2xl" data-id="element-187" data-mp="1ftnjh9kv4z78">
          <p className="text-xl leading-relaxed text-white/85 sm:text-2xl" data-id="element-188" data-mp="1fscbexkdx5ab">
            Tal vez no necesitás más tiempo.
          </p>
          <p className="mt-4 text-2xl font-bold leading-relaxed sm:text-3xl" data-id="element-189" data-mp="28b871y817djf">
            Tal vez necesitás dejar de compararte y empezar a construir tu propio camino.
          </p>
          <p className="mt-6 text-xl font-medium text-[#f5a623] sm:text-2xl" data-id="element-190" data-mp="2av5xqcwm1wo9">
            Y eso puede empezar hoy.
          </p>
          <div className="mt-10 flex flex-col items-center" data-id="element-191" data-mp="2ftftopq5t1ax">
            <CTAButton size="lg" data-id="element-192" data-mp="2fw29fcn7en48">Empezar mi camino hoy</CTAButton>
            <ArrowDownIcon className="mt-6 h-6 w-6 animate-bounce text-white/40" data-id="element-193" data-mp="2krr3j0ggfbt5" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-white px-5 py-10 text-center" data-id="element-194" data-mp="2tua2val176an">
        <p className="text-sm font-bold uppercase tracking-wide text-[#0d1b3e]" data-id="element-195" data-mp="2trxof7ehfe2c">
          📘 Todos Avanzan Menos Vos
        </p>
        <p className="mt-2 text-xs text-gray-400" data-id="element-196" data-mp="33k3egbl6blew">
          © {new Date().getFullYear()} · Producto digital. Todos los derechos reservados.
        </p>
      </footer>
    </main>;
}